import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tooltip.html";
import { WireI18n } from '~/modules/stores/i18nStore';
export let NubbinPosition = /*#__PURE__*/function (NubbinPosition) {
  NubbinPosition["Left"] = "left";
  NubbinPosition["LeftTop"] = "left-top";
  NubbinPosition["LeftBottom"] = "left-bottom";
  NubbinPosition["TopLeft"] = "top-left";
  NubbinPosition["TopRight"] = "top-right";
  NubbinPosition["RightTop"] = "right-top";
  NubbinPosition["RightBottom"] = "right-bottom";
  NubbinPosition["BottomLeft"] = "bottom-left";
  NubbinPosition["BottomRight"] = "bottom-right";
  return NubbinPosition;
}({});
export let Position = /*#__PURE__*/function (Position) {
  Position["Default"] = "";
  Position["Right"] = "right"; //implemet other positions as needed
  return Position;
}({});
class Tooltip extends LightningElement {
  constructor(...args) {
    super(...args);
    this.content = void 0;
    this.tooltipTitle = 'Dialog info';
    // Defines where will the nubbin triangle be
    this.nubbinPosition = NubbinPosition.BottomRight;
    this.positioning = Position.Default;
    this.customTooltipClass = '';
    this._hasRendered = false;
    this.sharedLabels = {};
    this.show = () => {
      const tooltip = this.template.querySelector('section');
      tooltip.classList.remove('slds-popover_hide');
    };
  }
  i18nCallback(i18n) {
    this.sharedLabels = i18n.shared;
  }
  renderedCallback() {
    if (!this._hasRendered) {
      const button = this.template.querySelector('.tooltip-container');
      button === null || button === void 0 ? void 0 : button.addEventListener('mouseover', this.show);
      button === null || button === void 0 ? void 0 : button.addEventListener('focusin', this.show);
      this._hasRendered = true;
    }
  }
  get cssClassName() {
    return 'tooltip slds-popover slds-popover_medium slds-popover_hide slds-nubbin_' + this.nubbinPosition + ' tooltip_possition_' + this.positioning + (this.customTooltipClass ? ' ' + this.customTooltipClass : '');
  }
  handleCloseClick() {
    const tooltip = this.template.querySelector('section');
    if (!tooltip.classList.contains('slds-popover_hide')) {
      tooltip.classList.add('slds-popover_hide');
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Tooltip, {
  publicProps: {
    content: {
      config: 0
    },
    tooltipTitle: {
      config: 0
    },
    nubbinPosition: {
      config: 0
    },
    positioning: {
      config: 0
    },
    customTooltipClass: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["_hasRendered", "sharedLabels", "show"]
});
const __lwc_component_class_internal = _registerComponent(Tooltip, {
  tmpl: _tmpl,
  sel: "pricing-tooltip",
  apiVersion: 62
});
export default __lwc_component_class_internal;